import { defineComponent as _defineComponent } from 'vue'
import { ITermsInfo } from "@/domain/entities/serviceInfo/termsInfo";
import { useServiceStore } from "@/stores/serviceStore";
import { TermsTypeCode } from "@/types";
import useFormattingPhoneNumber from "@/use/useFormattingPhoneNumber";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInfo',
  props: {
  termsList: {
    type: Array as PropType<ITermsInfo[]>,
    required: true,
  },
},
  emits: ["onClickTerms"],
  setup(__props, { expose: __expose }) {
  __expose();





const serviceStore = useServiceStore();
const csCenterPhone = useFormattingPhoneNumber(
  serviceStore.serviceInfo?.csCenterPhone ?? "1661-0771"
);

const __returned__ = { serviceStore, csCenterPhone, get TermsTypeCode() { return TermsTypeCode } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})